module.exports = __webpack_public_path__ + "static/getstarted2-e14ca5dec2e583b3375af44a355fece8.jpg";